import * as React from 'react';

import { Text } from '@/decodo/components/atoms/Text';

export type AuthorItemProps = {
  image: React.ReactNode;
  name: string;
  title?: string;
  bio?: React.ReactNode;
};

export default function AuthorItem({
  image,
  name,
  title,
  bio,
}: AuthorItemProps) {
  return (
    <div className='rounded bg-gray-100 px-5 py-8 md:px-9 md:py-9'>
      <div className='flex pb-6'>
        <div className='w-17 h-full rounded-full pr-6'>{image}</div>
        <div className='grid place-content-center justify-items-start'>
          <Text className='text-subtitle-l-d font-serif text-gray-950'>
            {name}
          </Text>
          {title && <Text className='text-body-s text-gray-950'>{title}</Text>}
        </div>
      </div>
      {!!bio && <Text className='text-body-l text-gray-500'>{bio}</Text>}
    </div>
  );
}
